/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

export type PermissionCallback = (id: number | null, permission: boolean) => void;

const checkFunctions: Map<number, (callback: PermissionCallback) => void> = new Map();
let currentCallback: VoidFunction | null = null;

export function requestPageChangePermission(callback: VoidFunction) {
    const nextID = determineNextID();
    if (nextID === null) return callback();
    currentCallback = callback;
    requestPageChange(nextID);
}

function requestPageChange(id: number) {
    checkFunctions.get(id)?.(onAnswerPermissionRequest);
}

export function onAnswerPermissionRequest(id: number | null, permission: boolean | null) {
    if (permission === false) return;
    const nextID = determineNextID(id);
    if (nextID === null) currentCallback?.();
    else requestPageChange(nextID);
}

export function addPageChanger(func: (callback: PermissionCallback) => void, onlyWhenEmpty: boolean = true) {
    if (onlyWhenEmpty && checkFunctions.size) return null;
    const nextID = Math.max(0, ...checkFunctions.keys()) + 1;
    checkFunctions.set(nextID, func);
    return nextID;
}

export function removePageChanger(id: number) {
    checkFunctions.delete(id);
}

function determineNextID(id?: number | null): number | null {
    const ids = Array.from(checkFunctions.keys());
    ids.sort();
    if (!ids.length) return null;
    if (id === undefined || id === null) return ids[0];
    for (let idx = 0; idx < ids.length; idx++) {
        if (idx === ids.length - 1) return null;
        else if (ids[idx] === id) return ids[idx + 1];
    }
    return null;
}
